/* eslint-disable camelcase */

export default api => {
  function getReports(query) {
    return api.get(`/_svc/slapi-v1/reports${query}`);
  }

  // Export Reports
  function postReports(link, param) {
    return api.post(`/_svc/slapi-v1${link}`, param);
  }

  function getSales(query) {
    return api.get(`/_svc/slapi-v1/sales/list${query ? "?" + query : ""}`);
  }

  function getSalesItemDetails(query) {
    return api.get(`/_svc/slapi-v1/sales/detailed${query ? "?" + query : ""}`);
  }

  function getSalesStatus() {
    return api.get(`/_svc/slapi-v1/sales/statuses`);
  }

  return {
    getReports,
    postReports,
    getSales,
    getSalesStatus,
    getSalesItemDetails,
  };
};



// WEBPACK FOOTER //
// ./src/services/ReportsServices.js